import { select } from '@angular-redux/store';
import { Inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable ,  Subject } from 'rxjs';

import { ApplicationUser } from '../models/application.user.interface';
import { ChannelEvent } from './channel.event.factory';
import { environment } from '../../../environments/environment';
import * as signalR from "@microsoft/signalr"

export class SignalrWindow extends Window {
  public $: any;
}


export function getWindow() { return window; }

// tslint:disable-next-line:max-classes-per-file
class ChannelSubject {
  public channel: string;
  public subject: Subject<ChannelEvent>;
}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class ChannelService {

  public starting$: Observable<any>;
  public connectionState$: Observable<signalR.HubConnectionState>;
  public error$: Observable<string>;
  @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;

  private connectionStateSubject = new Subject<signalR.HubConnectionState>();
  private startingSubject = new Subject<any>();
  private errorSubject = new Subject<any>();
  private hubConnection: signalR.HubConnection;
  private subjects: ChannelSubject[] = [];
  private events: ChannelEvent[] = [];
  private myChannels: string[] = [];
  private hubName: string = 'event';
  private hubUrl: string = environment.hubEndpointAddress + '/event';
  private userId: string = '';

  constructor(
    @Inject(SignalrWindow) private window: SignalrWindow,
    private readonly logger: NGXLogger,
  ) {
    /*if (this.window.$ === undefined || this.window.$.hubConnection === undefined) {
      // tslint:disable-next-line:max-line-length
      throw new Error('The variable "$" or the .hubConnection() function are not defined...please check the SignalR scripts have been loaded properly');
    }*/

    this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.userId = applicationUser.id;
      }
    });

    this.connectionState$ = this.connectionStateSubject.asObservable();
    this.error$ = this.errorSubject.asObservable();
    this.starting$ = this.startingSubject.asObservable();

    this.hubConnection = this.createHubConnection();

    /*this.hubConnection.stateChanged((state: any) => {
      let newState = ConnectionState.Connecting;

      switch (state.newState) {
        case this.window.$.signalR.connectionState.connecting:
          newState = ConnectionState.Connecting;
          break;
        case this.window.$.signalR.connectionState.connected:
          newState = ConnectionState.Connected;
          break;
        case this.window.$.signalR.connectionState.reconnecting:
          newState = ConnectionState.Reconnecting;
          break;
        case this.window.$.signalR.connectionState.disconnected:
          newState = ConnectionState.Disconnected;
          break;
      }
      this.connectionStateSubject.next(newState);
      if (newState === ConnectionState.Connected) {
        setTimeout(() => { this.publishFromQueue(); }, 4000);
      }
    });

    this.hubConnection.error((error: any) => {
      // Push the error on our subject
      //
      this.errorSubject.next(error);
    });*/

    this.hubConnection.on('onEvent', (channel: string, ev: ChannelEvent) => {
      const channelSub = this.subjects.find((x: ChannelSubject) => {
        return x.channel === channel;
      }) as ChannelSubject;

      if (channelSub !== undefined && channelSub != null) {
        return channelSub.subject.next(ev);
      }
    });

    this.hubConnection.onclose(() => {
      this.logger.error('SignalR disconnected for all channels on the client', this.userId,
        'disconnected', 'SIGNALR', '');

      const that = this;
      setTimeout(async () => {
        try
        {
          await that.hubConnection.start(/*{ withCredentials: false }*/);
          that.logger.debug('Trying to restart the connection for all channels', this.userId,
              'starting', 'SIGNALR');
            that.startingSubject.next();
            that.myChannels.forEach(async (channel) => {
              const channelSub = new ChannelSubject();
              channelSub.channel = channel;
              channelSub.subject = new Subject<ChannelEvent>();
              that.subjects.push(channelSub);
              try
              {
                await that.hubConnection.invoke('subscribe', channel);
                that.logger.debug('Reconnected to channel: ${channel}', this.userId, 'subscribing', 'SIGNALR');
              }
              catch(error)
              {
                that.logger.error(error, this.userId, 'subscribing', 'SIGNALR');
                channelSub.subject.error(error);
              }
            });
        }
        catch(error)
        {
          that.logger.error(error, this.userId, 'subscribing', 'SIGNALR');
          that.startingSubject.error(error);
        }
      });
    });
  }

  createHubConnection(): any {
    return new signalR.HubConnectionBuilder()
    .withUrl(this.hubUrl, {withCredentials: false , skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets})
    .configureLogging(signalR.LogLevel.Information)
    .build();
  }

  public start(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try
      {
        if(this.hubConnection.state == signalR.HubConnectionState.Connected)
        {
          this.logger.debug('SignalR already started', this.userId, 'start', 'SIGNALR', '');
        }
        else
        {
          await this.hubConnection.start();
          this.logger.debug('SignalR started', this.userId, 'start', 'SIGNALR', '');
        }
        this.startingSubject.next();
        resolve('ok');
      }
      catch(error)
      {
        this.logger.error('Failed to start signalr', this.userId, 'starting', 'SIGNALR', '');
        this.startingSubject.error(error);
        reject();
      }
    });

  }

  public sub(channel: string): Observable<ChannelEvent> {
    if (this.myChannels.findIndex((c) => c === channel) < 0) {
      this.myChannels.push(channel);
    }
    let channelSub = this.subjects.find((x: ChannelSubject) => {
      return x.channel === channel;
    }) as ChannelSubject;

    if (channelSub !== undefined && channelSub != null) {
      this.logger.debug('Found existing observable for channel: ' + channel, this.userId, 'start', 'SIGNALR', '');
      return channelSub.subject.asObservable();
    }

    channelSub = new ChannelSubject();
    channelSub.channel = channel;
    channelSub.subject = new Subject<ChannelEvent>();
    this.subjects.push(channelSub);

    this.hubConnection.invoke('subscribe', channel)
      .then(() => {
        this.logger.debug('Successfully subscribed to channel: ' + channel, this.userId, 'start', 'SIGNALR', '');
      })
      .catch((error: any) => {
        channelSub.subject.error(error);
      });

    return channelSub.subject.asObservable();
  }

  public publish(ev: ChannelEvent): void {
    if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
      if(this.events.length === 0) {
        this.hubConnection.invoke('publish', ev);
      }
      else {
        this.events.push(ev);
        this.publishFromQueue();
      }
    } else {
      this.events.push(ev);
    }
  }

  public publishFromQueue(): void {
    while (this.events.length > 0 && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.invoke('publish', this.events[0]);
      this.events.shift();
    }
  }
}
